/**
 *
 * PreventAutoComplete
 *
 *  This component exists due to the `autoComplete` not
 *  working in Chrome.
 *
 *  Usage: when two consective input fields exist of types 'text' and
 *  'password', place this component above to prevent the autofill of
 *  email and password.
 *
 */

import React from 'react';
import { Wrapper, Input } from './styledComponents'

const PreventAutoComplete = () => (
  <Wrapper>
    <Input readOnly type="text" name="fake_email"/>
    <Input readOnly type="password" name="fake_password"/>
  </Wrapper>
);

export default PreventAutoComplete;



// WEBPACK FOOTER //
// ./src/components/PreventAutoComplete/index.js